import {Template} from "../../../../../components/template/template.jsx";
import React from "react";
import {useParams} from "react-router";
import WorkScheduleFormPresentation from "./components/presentation/work-schedule-form-presentation.jsx";
import WorkScheduleFormCreateInit from "./components/create/work-schedule-form-create-init.jsx";
import './utils/work-schedule.css'

const WorkScheduleForm = () => {

    const {id} = useParams();

    return(
        <Template isLoading={false}>
            <Template.Header>
                <Template.Title>
                    Escala
                </Template.Title>
            </Template.Header>
            <Template.Body>
                {!id &&
                    <WorkScheduleFormCreateInit/>
                }
                {id &&
                    <WorkScheduleFormPresentation id={id}/>
                }
            </Template.Body>
        </Template>
    )
}

export default WorkScheduleForm;